import { isEmpty } from 'lodash';
import * as Yup from 'yup';

export const createValidationSchema = (originalPrice: string, originalUOM: string | undefined) =>
  Yup.object({
    itemName: Yup.string()
      .trim()
      .required('Description is required')
      .max(500, 'Description must be 500 characters or less'),
    price: Yup.string().test(
      'price-validation',
      'Price is required',
      function (value: string | undefined | null) {
        if (value === undefined || value === null) {
          return this.createError({ message: 'Price is required' });
        }

        const val: string = (value || '').trim();

        const normalizedValue = Number(parseFloat(val));
        const normalizedOriginal = parseFloat((originalPrice || '').trim());

        const hasChanged = normalizedValue !== normalizedOriginal;

        // If price hasn't changed, allow it (even if 0)
        if (!hasChanged) {
          return true;
        }

        // If price has changed, it must be required and greater than 0
        if (isEmpty(value)) {
          return this.createError({ message: 'Price is required' });
        }

        if (normalizedValue <= 0) {
          return this.createError({ message: 'Price must be greater than 0' });
        }

        return true;
      }
    ),
    uom: Yup.string()
      .trim()
      .test('uom-validation', 'UOM is a required field', function (value: string | undefined) {
        const val: string = (value || '').trim();
        const originalUOMVal: string = (originalUOM || '').trim();
        if (isEmpty(val) && !isEmpty(originalUOMVal)) {
          return this.createError({ message: 'UOM is a required field' });
        }
        if (isEmpty(originalUOMVal) && isEmpty(val)) {
          return true;
        }
        return true;
      })
      .max(50, 'UOM must be 50 characters or less'),
    brandName: Yup.string().trim().max(180, 'Brand Name must be 180 characters or less'),
    mfgName: Yup.string().trim().max(180, 'Manufacturer Name must be 180 characters or less'),
    manufacturerNumber: Yup.string()
      .trim()
      .max(60, 'Manufacturer Number must be 60 characters or less'),
    casePackUnits: Yup.string().trim().max(50, 'Case Pack Units must be 50 characters or less'),
    weight: Yup.string().trim().max(50, 'Weight must be 50 characters or less'),
    upc: Yup.string().trim().max(50, 'UPC must be 50 characters or less'),
    unspsc: Yup.string().trim().max(105, 'UNSPSC must be 105 characters or less'),
  });

// Backward compatibility: export a default schema with empty original price
export const validationSchema = createValidationSchema('', '');
